'use strict';

var cov_2a9z6aosx0 = function () {
  var path = '/codebuild/output/src396452290/src/apps/tnwi/temp/helpers/SecutixObjects/lib/AddressType.js',
      hash = 'd60ecf59e96763031cd770d5245df3b2424ffc16',
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = '__coverage__',
      coverageData = {
    path: '/codebuild/output/src396452290/src/apps/tnwi/temp/helpers/SecutixObjects/lib/AddressType.js',
    statementMap: {
      '0': {
        start: {
          line: 3,
          column: 20
        },
        end: {
          line: 13,
          column: 2
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      '0': 0
    },
    f: {},
    b: {},
    _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AddressType = (cov_2a9z6aosx0.s[0]++, _propTypes2.default.shape({
  addressLines: _propTypes2.default.arrayOf(_propTypes2.default.string),
  zipCode: _propTypes2.default.string,
  place: _propTypes2.default.string,
  countryCode: _propTypes2.default.string,
  phoneNumber: _propTypes2.default.string,
  faxNumber: _propTypes2.default.string,
  email: _propTypes2.default.string,
  gpsLatitude: _propTypes2.default.string,
  gpsLongitude: _propTypes2.default.string
}));

exports.default = AddressType;